// Copyright (c) 2017 Deere & Company

import moment from 'moment';

export const getCurrentFiscalYear = () => {

    const month = moment.utc().startOf('day').month() + 1;

    const year = moment.utc().startOf('day').year();

    return (month <= 10 ? year : year + 1);

};



// WEBPACK FOOTER //
// ./src/reports/audit-summary/report-services/get-current-fiscal-year.js